import WorkflowService from '../../../../../../services/WorkflowService'

class FullListingDTOsDecorator {
  findAll () {
    return WorkflowService.findAll()
  }
}

export default new FullListingDTOsDecorator()
